import { makeStyles } from '@material-ui/styles';

export const useStyles = (maxWidth) =>
    makeStyles(() => ({
        seat: {
            [`@media all and (max-width: ${maxWidth}px)`]: {
                height: '56px',
                flex: '0 0 56px',
            },
        },
    }));
